export default "__VITE_ASSET__952ea8b6__"